import { DICTIONARY } from 'Enum';
import { Dictionary } from 'Dictionary';
import { CustomMetaTitle, LinkReturnToMain, Loader } from 'Components';
import { Title } from './Title';
import { useAppSelector, useDictionary, useIsDesktop } from 'Hooks';
import { Stack, Typography } from '@mui/material';
import { PrescIdentifierType, getMedicationByID } from 'API';
import { useParams } from 'react-router-dom';
import { useCallback, useEffect, useState } from 'react';
import { MedicineOrderStatus } from './MedicineOrderStatus';
import { MedicineList } from './MedicineList';

export const MedicineOrderInfo = () => {
  const imposterId = useAppSelector(
    ({ imposter: { imposterId } }) => imposterId
  );
  const [medicineOrderInfo, setMedicineOrderInfo] = useState<any | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  //change to IPrescription after the server will be ready
  const isDesktop = useIsDesktop();
  const params = useParams();

  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.MedicationsAndPrescriptionsLobby
  );

  const initMedicineOrderInfo = useCallback(async () => {
    const equipType =
      params.id && params.id?.length < 12
        ? PrescIdentifierType.OriginalOrderId
        : PrescIdentifierType.PrescShemeshCode;
    const medicineOrderInfo = await getMedicationByID(params.id, equipType);

    if (medicineOrderInfo) {
      setMedicineOrderInfo(medicineOrderInfo);
      setIsLoading(false);
    }
  }, [params.id]);

  useEffect(() => {
    initMedicineOrderInfo();
    window.scrollTo(0, 0);
  }, [imposterId]);
  return isLoading ? (
    <Loader />
  ) : (
    <>
      <CustomMetaTitle title={dictionary.title} />
      <LinkReturnToMain
        link='/medicine'
        label={dictionary.breadcrumbs}
        internal
      />

      {medicineOrderInfo && (
        <Stack
          gap={isDesktop ? '28px' : '32px'}
          maxWidth={isDesktop ? '960px' : 'initial'}
          mt={isDesktop ? '30px' : '24px'}
        >
          <Title order={medicineOrderInfo} />
          <Stack>
            <MedicineOrderStatus order={medicineOrderInfo} />
            <MedicineList
              orderItems={medicineOrderInfo.medications}
              currentStatus={medicineOrderInfo.currentStatus}
              eligibleNotes={medicineOrderInfo.eligibleNotes}
            />
          </Stack>
        </Stack>
      )}
    </>
  );
};
